import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const gritComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    popup: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      top: '0vh',
      // bottom: 0,
      height: '89vh',
      zIndex: 100,
      // padding: '10px',
      backgroundColor: 'white',
      color: '#000',
      border: '1px solid #000',
      borderRadius: 10,
      boxShadow: '0 0 20px 0 #444',
      overflow: 'hidden',
    },
    error: {
      color: '#d32f2f',
      marginBottom: 10,
    },
    claimsTransformationLeft: {
      width: '45%',
    },
    transformationExample: {
      backgroundColor: '#cecece',
      borderRadius: '10px',
      padding: 10,
      width: '50%',
      wordBreak: 'break-word',
    },
    selfAssertedPopup: {
      left: '0%',
      width: '99%',
    },
    validationPopup: {
      left: '5%',
      width: '95%',
    },
    debuggerPopup: {
      top: '2vh',
      height: '88vh',
      left: '74%',
      width: '25%',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexColfill: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: '1',
      padding: '10vh',
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    flexRowWrap: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    flexRowCenter: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    border: {
      margin: '10px 0 20px 0',
      background: '#ebecF0',
      border: '1px solid grey',
      borderRadius: '5px',
      padding: '10px',
    },
    header: {
      width: '100%',
      height: '60px',
      alignItems: 'center',
      background: '#373737',
      color: '#FFFFFF',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',

      '& div': {
        marginLeft: 10,
      },
    },
    footer: {
      marginTop: 10,
      display: 'flex',
      flexDirection: 'row-reverse',
      '& button': {
        marginLeft: '1rem',
      },
    },
    alignCenter: {
      alignItems: 'center',
    },
    delete: {
      border: '1px solid grey',
      marginRight: '1rem',
      cursor: 'pointer',
      backgroundColor: 'red',
    },
    input: {
      borderRadius: '5px',
      padding: '8px',
      width: '400px',
    },
    mt1: {
      marginTop: '1rem',
    },
    mb1: {
      marginBottom: '1rem',
    },
    form: {
      width: '500px',
    },
    actionName: {
      marginRight: '1rem',
    },
    policyEntry: {
      height: '30px',
    },
    label: {
      width: '330px',
    },
    value: {
      marginLeft: '1rem',
      width: '200px',
    },
    icon: {
      cursor: 'pointer',
      marginLeft: '0.5rem',
    },
    policyBody: {
      flex: 1,
      height: 'inherit',
      overflow: 'hidden',
    },
    showPolicy: {
      overflowY: 'scroll',
      paddingLeft: '10px',
      flexBasis: '40%',
      flex: 1,

      '&::-webkit-scrollbar': {
        width: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#1976d2',
        borderRadius: '1ex',
        boxShadow: '0px 1px 2px rgba(0,0,0,0.75)',
      },
    },
    editPolicy: {
      overflowY: 'scroll',
      borderLeft: '1px solid #444',
      scrollbarWidth: 'thin',
      // boxShadow: '0 0 20px 0 #444',
      flex: 1,
      flexBasis: '60%',
      padding: '1rem',

      '&::-webkit-scrollbar': {
        width: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#1976d2',
        borderRadius: '1ex',
        boxShadow: '0px 1px 2px rgba(0,0,0,0.75)',
      },
    },
    heading: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginTop: '1rem',
      marginBottom: '0.5rem',
    },
    subHeading: {
      marginBottom: '0.5rem',
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    listFileContainer: {
      margin: '10px 0 20px 0',
      background: 'white',
      border: '1px solid grey',
      boxShadow: '0px 0px 20px -7px #000000',
      borderRadius: '5px',
      padding: '10px',
      minHeight: '10vh',
    },
  }),
);

export { gritComponentStyles };
